import { supabase } from '@core/providers/supabase/supabase';

export async function getAccessToken(): Promise<string | null> {
    const { data } = await supabase.auth.getSession();
    return data.session?.access_token ?? null;
}

export async function refreshSession(): Promise<void> {
    const { data, error } = await supabase.auth.refreshSession();
    if (error || !data.session) {
        throw error ?? new Error('Failed to refresh session');
    }
}
